import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

export interface CourseCategory {
    id: number;
    name: string;
    course_category_id: string;
}

export interface Subject {
    id: number;
    name: string;
}

export interface TutorCourse {
    id: number;
    full_name: string;
    short_name: string;
    course_id: string; // The UUID string
    course_category: CourseCategory;
    subjects: Subject[];
    description: string;
    start_date: string | null;
    end_date: string | null;
    image: string | null;
    status: boolean;
    created_at: string;
    updated_at: string | null;
    yeargroup_country_map: any[];
    course_tutor_map_id: any | null;
    duration?: string;
    students?: number;
}

const initialState: IReduxState<TutorCourse[]> = {
    data: {
        status: false,
        message: "",
        data: []
    },
    isLoading: false,
    error: null
} as IReduxState<TutorCourse[]>;

export const TutorCoursesSlice = createSlice({
    name: "TutorCoursesSlice",
    initialState,
    reducers: {
        getTutorCourses: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        successGetTutorCourses: (state, action: PayloadAction<IAPIResponse<TutorCourse[]>>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureGetTutorCourses: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    getTutorCourses,
    successGetTutorCourses,
    failureGetTutorCourses,
} = TutorCoursesSlice.actions;

export default TutorCoursesSlice.reducer;
